import { render, staticRenderFns } from "./BranceBankDetail.vue?vue&type=template&id=15dc0b19"
import script from "./BranceBankDetail.vue?vue&type=script&lang=js"
export * from "./BranceBankDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports